// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import Cache from '../Cache';

const NOTIFICATION_DEFAULTS = { position: 'tr', autoDismiss: 3 };

export const NOTIFICATION_CONTEXT_TYPES = {
  onError: PropTypes.func.isRequired,
  onInfo: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onWarning: PropTypes.func.isRequired
};

/**
 * Provides the notification handler functions to the children elements
 */
export default class NotificationSystemProvider extends Component {
  static contextTypes = {
    session: PropTypes.object,
  };

  static childContextTypes = NOTIFICATION_CONTEXT_TYPES;

  // lifecycle
  getChildContext() {
    return {
      onError: this.handleError,
      onWarning: this.handleWarning,
      onInfo: this.handleInfo,
      onSuccess: this.handleSuccess
    };
  }

  handleNotification(level: string, notification: string | Error, options: Object) {
    const { notificationSystem } = this.refs;
    let message = notification;

    if (notification instanceof Error) {
      /* eslint-disable */
      console.error(notification);
      /* eslint-enable */
      message = notification.message;
    }

    if (message === 'Unknown network error occurred.') return;

    if (notificationSystem) {
      notificationSystem.addNotification({ ...NOTIFICATION_DEFAULTS, level, message, ...options });
    } else {
      /* eslint-disable */
      console[ level ].apply(console, arguments);
      /* eslint-enable */
    }
  };

  // handlers
  handleError = (err: string | Error, options: Object) => {
    const isStringErrorMessage = typeof err === 'string';
    if (isStringErrorMessage || (err.message && err.message !== 'OFFLINE')) {
      this.handleNotification('error', err, options);
      if (err.status && err.status === 403) {
        // Check if the token has expired.
        const tokenHasExpired = parseInt(Cache.getTokenExpiration()) < Date.now();
        tokenHasExpired && this.context.session.login();
      }
    }
  };

  handleInfo = (message: string, options: Object) => this.handleNotification('info', message, options);
  handleSuccess = (message: string, options: Object) => this.handleNotification('success', message, options);
  handleWarning = (message: string, options: Object) => this.handleNotification('warning', message, options);

  render() {
    const { children, ...rest } = this.props;

    return (
      <div {...rest}>
        {children}
        <NotificationSystem key="notifications" ref='notificationSystem'/>
      </div>
    );
  }
}